import { request } from "./request";

export interface ResolveEmulationRequest {
  readonly emulation_id: string;
}

export interface ResolveEmulationResponse {
  readonly auth_token: string;
  readonly refresh_token: string;
  readonly parent_identity: string;
}

export const resolveEmulation = async (emulationId: string) => {
  return request<ResolveEmulationRequest, ResolveEmulationResponse>({
    endpoint: "/emulation/resolve",
    body: { emulation_id: emulationId },
    api: "authnz",
  });
};
